<div class="wrapper-feedback-form">
	<div class="section-title">
		<div class="row">
			<div class="col">
				<div class="d-flex align-items-center">
					<a routerLink="/dashboard/gallery" class="btn btn-back" [attr.aria-label]="'Back' | translate">
						<i class="fi-rr-arrow-alt-left"></i>
					</a>
					<div class="title" [attr.data-parent]="'Media Library' | translate">{{ "Create Media" | translate }}</div>
				</div>
			</div>
		</div>
	</div>

	<div class="section-main">
		<form [formGroup]="mediaForm" (ngSubmit)="createMedia()">
			<div class="row">
				<div class="col-12 col-lg-9 col-xl-8">

					<div *ngIf="isUploading" class="loading-preload">
						<div class="loading-spinner col-12">
							<mat-spinner class="mx-auto my-3" [diameter]="50"></mat-spinner>
							<p class="upload-status text-center" *ngIf="uploadStatus">{{ uploadStatus }}</p>
						</div>
					</div>

					<!-- Images / Videos -->
					<div class="card mt-4">
						<div class="d-flex align-items-center justify-content-between">
							<h4 class="card-heading mb-0">{{ "Images / Videos" | translate }}</h4>
							<span class="file-count" [class.file-count-full]="mediaItems.length >= MAX_FILES">{{ mediaItems.length }} / {{ MAX_FILES }}</span>
						</div>

						<div class="custom-dropzone mt-3" ngx-dropzone [multiple]="true" [accept]="UPLOAD_ACCEPT"
							(change)="onSelect($event)"
							[ngClass]="{'custom-dropzone-error': imagesError}">
							<ngx-dropzone-label>
								<div class="dz-label">
									<h2>{{ "Select your files or drop them here" | translate }}</h2>
									<p>{{ "Up to {0} files (images or videos), max {1}MB each" | translate:[MAX_FILES, MAX_UPLOAD_SIZE_MB] }}</p>
									<p>{{ "Supported formats: {0}" | translate:[SUPPORTED_FORMATS] }}</p>
								</div>
							</ngx-dropzone-label>
						</div>

						<span class="field-error d-block mt-2" *ngIf="imagesError">{{ "At least one image or video is required." | translate }}</span>
						<span class="field-error d-block mt-2" *ngFor="let msg of limitMsgs">{{ msg }}</span>

						<!-- Per-file editable list -->
						<div class="media-list mt-3" formArrayName="items">
							<div class="media-item" *ngFor="let item of items.controls; let i = index" [formGroupName]="i"
								(dragover)="$event.preventDefault()" (drop)="$event.preventDefault()">
								<div class="media-thumb">
									<video *ngIf="mediaItems[i].isVideo" [src]="mediaItems[i].previewUrl" muted playsinline></video>
									<img *ngIf="!mediaItems[i].isVideo" [src]="mediaItems[i].previewUrl" alt="">
								</div>
								<div class="media-fields">
									<div class="media-field">
										<label>{{ "Title" | translate }} <span class="req">*</span></label>
										<input class="form-control" type="text" formControlName="title"
											[attr.maxlength]="TITLE_MAX"
											[ngClass]="{'form-control-error': item.get('title').errors && item.get('title').touched}">
									</div>
									<div class="media-field">
										<label>{{ "Caption" | translate }}</label>
										<input class="form-control" type="text" formControlName="caption"
											[attr.maxlength]="CAPTION_MAX"
											[ngClass]="{'form-control-error': item.get('caption').errors && item.get('caption').touched}">
									</div>
									<div class="media-field">
										<label>{{ "Alt Text" | translate }}</label>
										<input class="form-control" type="text" formControlName="alt_text"
											[attr.maxlength]="ALT_MAX"
											[ngClass]="{'form-control-error': item.get('alt_text').errors && item.get('alt_text').touched}">
									</div>
								</div>
								<button type="button" class="media-remove" (click)="onRemove(i)" [disabled]="isUploading" [attr.aria-label]="'Remove' | translate">
									<i class="fi-rr-cross-small"></i>
								</button>
							</div>
						</div>
					</div>

					<div class="mt-3 mb-4 text-right">
						<button class="btn btn-primary" type="submit" [disabled]="isUploading">{{ "Create Media" | translate }}</button>
					</div>

				</div>
			</div>
		</form>
	</div>
</div>
